import { Component, inject } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';
import { ModalService } from '@shared/services/modal.service';

@Component({
  templateUrl: 'horizontal-field-wrapper.component.html',
  styleUrls: ['horizontal-field-wrapper.component.scss'],
  imports: [...MSS_FORMLY_IMPORTS],
})
export class HorizontalFieldWrapperComponent extends FieldWrapper {
  private readonly modalService = inject(ModalService);

  public openTooltip() {
    this.modalService
      .open({
        title: this.props.label !== undefined ? this.props.label : this.props.addText,
        message: this.props.tooltip,
      })
      .then(
        () => null,
        () => null,
      );
  }

  public close() {
    this.modalService.close();
  }

  public get showGroupField() {
    if (!this.props.groupedField) {
      return true;
    }
    if (this.field.fieldGroup) {
      return !this.field.fieldGroup.some(field => field.formControl?.errors);
    }
  }

  public get showMandatoryIndicator() {
    const mandatoryIndicator = this.field.props?.showMandatoryIndicator;

    if (typeof mandatoryIndicator === 'boolean') {
      return mandatoryIndicator;
    }

    const hasDefault = this.field.defaultValue !== undefined && this.field.defaultValue !== null;

    // Check if the field has a greater than validator, which means they are mandatory.
    const hasGreaterThanValidator =
      Array.isArray(this.field.validators?.validation) &&
      this.field.validators.validation.some(
        v => typeof v === 'function' && (v.toString().includes('greaterThan') || v.toString().includes('greaterThanOnTouched')),
      );

    return (!hasDefault || hasGreaterThanValidator) && this.props.required && !this.props.nested;
  }
}
